import React, { Component } from 'react';
import styles from './AppFormStyles.module.scss'

class AppFormPage extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div className={`${styles.backgroundWrap}`}>
                <div className={`${styles.formWrap} text-center`}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default AppFormPage;
